<div class="page-container">
    <!-- Unified Header -->
    <div class="unified-header">
        <div class="header-left">
            <button mat-icon-button (click)="goBack()" class="circular-button back-button" matTooltip="Regresar">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h1 class="page-title">
                <mat-icon class="title-icon">settings_suggest</mat-icon>
                Procesar Documentos
            </h1>
        </div>
        <div class="analysis-status-container">
            <app-analysis-status-card></app-analysis-status-card>
        </div>
    </div>

    @if (isLoadingSignal()) {
    <div class="spinner-container">
        <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
    </div>
    } @else {

    <!-- Filtros (Sin cambios mayores, solo visual) -->
    <mat-expansion-panel class="filters-panel-compact" [expanded]="false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div style="display: flex; align-items: center; gap: 6px;">
                    <mat-icon>filter_list</mat-icon>
                    <span>Filtros</span>
                </div>
            </mat-panel-title>
            <mat-panel-description>
                <span>{{ filteredDocsSignal().length }} documentos</span>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="filtroForm" class="filtros-form-compact">
            <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                <mat-label>Buscar por Folio</mat-label>
                <input matInput formControlName="folio" [formControl]="folioFilterCtrl">
                <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" class="dense-field status-field" subscriptSizing="dynamic">
                <mat-label>Estatus</mat-label>
                <mat-select [formControl]="statusFilterCtrl">
                    <mat-option value="">Todos</mat-option>
                    <mat-option value="PENDIENTE_ANALISIS">Pendiente</mat-option>
                    <mat-option value="EN_PROCESO">En Proceso</mat-option>
                    <mat-option value="COMPLETADO">Completado</mat-option>
                    <mat-option value="ERROR">Error</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="dense-field date-field" subscriptSizing="dynamic">
                <mat-label>Rango de Fechas</mat-label>
                <mat-date-range-input [formGroup]="rangoFechasFormGroup" [rangePicker]="pickerFechas">
                    <input matStartDate formControlName="inicio" placeholder="Fecha inicio"
                        [formControl]="startDateFilterCtrl" [readonly]="isLoadingSignal()" />
                    <input matEndDate formControlName="fin" placeholder="Fecha fin" [formControl]="endDateFilterCtrl"
                        [readonly]="isLoadingSignal()" />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="pickerFechas"
                    [disabled]="isLoadingSignal()"></mat-datepicker-toggle>
                <mat-date-range-picker #pickerFechas></mat-date-range-picker>
            </mat-form-field>

            <div class="filter-actions">
                <button mat-icon-button color="primary" (click)="limpiarFiltros()" type="button"
                    matTooltip="Limpiar Filtros">
                    <mat-icon>filter_alt_off</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="loadData(true)" type="button" matTooltip="Refrescar">
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
        </form>
    </mat-expansion-panel>

    <!-- BARRA DE CONTROLES SUPERIORES (ACCIONES MASIVAS) -->
    <div class="controles-superiores">

        <!-- Checkbox Seleccionar Todo -->
        <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [disabled]="filteredDocsSignal().length === 0 || isProcessingBatch()"
            matTooltip="Seleccionar todos los visibles">
            Sel. Todos ({{ filteredDocsSignal().length }})
        </mat-checkbox>

        <span class="divider-vertical"></span>

        <!-- Botones de Acción Masiva (Visibles si hay selección) -->
        @if (selection.hasValue()) {
        <div class="bulk-actions" style="display: flex; gap: 8px; align-items: center;">
            <span class="selection-count">{{ selectedCount() }} seleccionados</span>

            <button mat-stroked-button color="primary" (click)="onAnalyzeSelected()" [disabled]="isProcessingBatch()">
                <mat-icon>analytics</mat-icon> Analizar
            </button>

            <button mat-stroked-button color="accent" (click)="onResetSelected()" [disabled]="isProcessingBatch()">
                <mat-icon>restart_alt</mat-icon> Reiniciar
            </button>

            <button mat-stroked-button color="warn" (click)="onDeleteSelected()" [disabled]="isProcessingBatch()">
                <mat-icon>delete</mat-icon> Borrar
            </button>

            @if (isProcessingBatch()) {
            <mat-spinner diameter="24"></mat-spinner>
            }
        </div>
        } @else {
        <!-- Controles por defecto cuando no hay selección -->
        <mat-button-toggle-group [value]="selectedProcessor()" (change)="onProcessorChange($event)"
            style="margin-right: 16px;">
            @for (option of processorOptions; track option.value) {
            <mat-button-toggle [value]="option.value" [matTooltip]="option.description" [disabled]="option.disabled">
                {{ option.label }}
            </mat-button-toggle>
            }
        </mat-button-toggle-group>

        <button mat-raised-button color="primary" (click)="startFullAnalysis()"
            [disabled]="analysisStatusSignal().is_processing"
            matTooltip="Inicia el análisis de todos los documentos pendientes en secuencia">
            <mat-icon>play_circle_filled</mat-icon>
            Iniciar Análisis Completo
        </button>
        }

        <span class="spacer"></span>

        @if (filteredDocsSignal().length > 0) {
        <mat-paginator [length]="filteredDocsSignal().length" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
            [pageSizeOptions]="[10, 20, 50]" (page)="handlePageEvent($event)" showFirstLastButtons>
        </mat-paginator>
        }
    </div>

    <!-- LISTA DE DOCUMENTOS -->
    <div class="accordion-container">
        @if (paginatedDocsSignal().length > 0) {
        <mat-accordion [multi]="false" class="facturas-accordion">
            @for (doc of paginatedDocsSignal(); track doc.id) {
            <mat-expansion-panel [class.deleting-row]="deletingIds().has(doc.id)"
                [disabled]="deletingIds().has(doc.id)">
                <mat-expansion-panel-header>
                    <mat-panel-title class="panel-title-container">
                        <!-- Checkbox Individual -->
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggleRow(doc.id) : null"
                            [checked]="selection.isSelected(doc.id)"
                            [disabled]="isProcessingBatch() || deletingIds().has(doc.id)" class="panel-checkbox">
                        </mat-checkbox>

                        <!-- Folio Group -->
                        <div class="factura-info-group">
                            <div class="info-item">
                                <span class="info-label">Folio:</span>
                                <span class="info-value folio">{{ doc.folio }}</span>
                                <button mat-icon-button class="copy-button" [cdkCopyToClipboard]="doc.folio"
                                    (click)="$event.stopPropagation()" matTooltip="Copiar Folio">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </div>
                            <div class="info-item id-item">
                                <span class="info-label">ID:</span>
                                <span class="info-value">{{ doc.id | slice:0:8 }}...</span>
                            </div>
                        </div>

                        <!-- File Count Group -->
                        <div class="factura-info-group">
                            <div class="info-item">
                                <span class="info-label">Archivos:</span>
                                <span class="info-value">{{ doc.files.length }}</span>
                            </div>
                        </div>

                        <!-- Status Group -->
                        <div class="factura-info-group status-group">
                            @if (deletingIds().has(doc.id)) {
                            <span class="factura-info estatus status-DELETING">
                                <mat-spinner diameter="14"
                                    style="display:inline-block; vertical-align:middle; margin-right:4px"></mat-spinner>
                                ELIMINANDO
                            </span>
                            } @else {
                            <span class="factura-info estatus status-{{ doc.status }}">
                                {{ doc.status }}
                            </span>
                            }
                        </div>

                        <!-- Date Group -->
                        <div class="factura-info-group align-right">
                            <div class="info-item">
                                <span class="info-label">Creado:</span>
                                <span class="info-value">{{ doc.createdAt | date:'dd/MM/yy HH:mm' }}</span>
                            </div>
                        </div>

                        <!-- Actions Group (VACÍO - Botones movidos a selección múltiple) -->
                        <div class="factura-info-group align-right actions-group">
                            <!-- NUEVO BOTÓN: Ver Logs de Análisis -->
                            <!-- Se muestra si hay logs guardados O si está en estado final (para intentar ver si hay algo) -->
                            @if (doc.analysis_logs || doc.status === 'COMPLETADO' || doc.status === 'ERROR') {
                            <button mat-icon-button color="accent" (click)="$event.stopPropagation(); onViewLogs(doc)"
                                matTooltip="Ver Detalles Técnicos del Análisis (Prompts & Respuestas)">
                                <mat-icon>terminal</mat-icon>
                            </button>
                            }

                            <!-- Solo dejamos un indicador visual si está en proceso -->
                            @if (doc.status === 'EN_PROCESO') {
                            <mat-spinner diameter="20"></mat-spinner>
                            }
                        </div>

                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="factura-detalle">
                    <div class="detalle-grid">
                        <div class="detalle-seccion">
                            <h4>Detalles del Documento</h4>
                            <p><strong>ID Completo:</strong> <span>{{ doc.id }}</span></p>
                            <p><strong>Folio:</strong> <span>{{ doc.folio }}</span></p>
                            <p><strong>Estatus:</strong> <span>{{ doc.status }}</span></p>
                            <p><strong>Tipo:</strong> <span>{{ doc.document_type }}</span></p>
                        </div>

                        <div class="detalle-seccion">
                            <h4>Archivos Adjuntos</h4>
                            @for (file of doc.files; track file.fileName) {
                            <div class="file-item"
                                style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px;">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <mat-icon class="small-icon">description</mat-icon>
                                    <span>{{ file.fileName }} ({{ (file.size / 1024).toFixed(2) }} KB)</span>
                                </div>
                                <div class="file-actions">
                                    <button mat-icon-button color="primary" (click)="onDownloadFile(doc, file)"
                                        matTooltip="Descargar/Ver">
                                        <mat-icon>visibility</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn" (click)="onRemoveFile(doc, file)"
                                        matTooltip="Eliminar Archivo">
                                        <mat-icon>delete_forever</mat-icon>
                                    </button>
                                </div>
                            </div>
                            }
                        </div>

                        <div class="detalle-seccion">
                            <h4>Análisis IA</h4>
                            <p><strong>Intentos:</strong> <span>{{ doc.ia_retries || 0 }}</span></p>

                            @if (doc.analysis_logs) {
                            <div style="margin-top: 12px;">
                                <button mat-stroked-button color="primary" (click)="onViewLogs(doc)">
                                    <mat-icon>history</mat-icon> Ver Historial Completo
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                </div>

            </mat-expansion-panel>
            }
        </mat-accordion>
        } @else {
        <div class="no-facturas">
            <mat-icon>inbox</mat-icon>
            <p>No se encontraron documentos.</p>
        </div>
        }
    </div>

    <!-- Bottom Paginator -->
    @if (filteredDocsSignal().length > pageSize()) {
    <div class="bottom-paginator">
        <mat-paginator [length]="filteredDocsSignal().length" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
            [pageSizeOptions]="[10, 20, 50]" (page)="handlePageEvent($event)" showFirstLastButtons>
        </mat-paginator>
    </div>
    }
    }
</div>